import axios from "axios";
import { toast } from "react-toastify";
import { API_ERROR_500 } from "../../../../../config";
import { setLoading, getStageScreen } from "../../../../../redux";

export const handleFileUpload = (data) => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.kyc_verification.api.signature_upload`,
        data,
        headers
      );
      dispatch(getStageScreen());
      dispatch(setLoading(false));
      toast.success("Signature Verification Successful");
    } catch (error) {
      const { response } = error;
      if (response?.data?.message) {
        toast.error(response?.data?.message);
      } else {
        toast.error(API_ERROR_500);
      }
      dispatch(setLoading(false));
    }
  };
};

export const handleCaptureFileUpload = (data) => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.kyc_verification.api.signature_upload`,
        data,
        headers
      );
      dispatch(setLoading(false));
      toast.success("Signature Verification Successful");
      dispatch(getStageScreen());
    } catch (error) {
      const { response } = error;
      if (response?.data?.message) {
        toast.error(response?.data?.message);
      } else {
        toast.error(API_ERROR_500);
      }
      dispatch(setLoading(false));
    }
  };
};
